import React from 'react'

const TickIcon = ({ color = '#000', className = '' }) => (
  <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 13.877 10.068">
    <path
      data-name="tick-svgrepo-com (4)"
      d="m4.892 12.159 3.374 3.374L15.8 8"
      transform="translate(-3.407 -6.515)"
      style={{
        fill: 'none',
        stroke: color,
        strokeLinecap: 'round',
        strokeLinejoin: 'round',
        strokeWidth: '2.1px',
      }}
    />
  </svg>
)

export default TickIcon
